import { PersonPreferenceViewModel, PersonPreferenceCreateCommand, PersonPreferenceUpdateCommand } from '../../models/Entities/Person/Preference/PersonPreferenceModels';
import { ErrorType } from '../../models/HttpError';

export const PERSON_PREFERENCE_GETALL_REQUEST = 'PERSON_PREFERENCE_GETALL_REQUEST';
export const PERSON_PREFERENCE_GETALL_SUCCESS = 'PERSON_PREFERENCE_GETALL_SUCCESS';
export const PERSON_PREFERENCE_GETALL_FAILURE = 'PERSON_PREFERENCE_GETALL_FAILURE';

export interface PersonPreferenceGetAllRequestAction {
    type: typeof PERSON_PREFERENCE_GETALL_REQUEST;
    personId: number;
}

export interface PersonPreferenceGetAllSuccessAction {
    type: typeof PERSON_PREFERENCE_GETALL_SUCCESS;
    personId: number;
    payload: PersonPreferenceViewModel[];
}

export interface PersonPreferenceGetAllFailureAction {
    type: typeof PERSON_PREFERENCE_GETALL_FAILURE;
    error: ErrorType;
}

export const PERSON_PREFERENCE_GETBYID_REQUEST = 'PERSON_PREFERENCE_GETBYID_REQUEST';
export const PERSON_PREFERENCE_GETBYID_SUCCESS = 'PERSON_PREFERENCE_GETBYID_SUCCESS';
export const PERSON_PREFERENCE_GETBYID_FAILURE = 'PERSON_PREFERENCE_GETBYID_FAILURE';

export interface PersonPreferenceGetByIdRequestAction {
    type: typeof PERSON_PREFERENCE_GETBYID_REQUEST;
    id: number;
}

export interface PersonPreferenceGetByIdSuccessAction {
    type: typeof PERSON_PREFERENCE_GETBYID_SUCCESS;
    payload: PersonPreferenceViewModel;
}

export interface PersonPreferenceGetByIdFailureAction {
    type: typeof PERSON_PREFERENCE_GETBYID_FAILURE;
    error: ErrorType;
}

export const PERSON_PREFERENCE_CREATE_REQUEST = 'PERSON_PREFERENCE_CREATE_REQUEST';
export const PERSON_PREFERENCE_CREATE_SUCCESS = 'PERSON_PREFERENCE_CREATE_SUCCESS';
export const PERSON_PREFERENCE_CREATE_FAILURE = 'PERSON_PREFERENCE_CREATE_FAILURE';

export interface PersonPreferenceCreateRequestAction {
    type: typeof PERSON_PREFERENCE_CREATE_REQUEST;
    payload: PersonPreferenceCreateCommand;
}

export interface PersonPreferenceCreateSuccessAction {
    type: typeof PERSON_PREFERENCE_CREATE_SUCCESS;
    payload: PersonPreferenceViewModel;
}

export interface PersonPreferenceCreateFailureAction {
    type: typeof PERSON_PREFERENCE_CREATE_FAILURE;
    error: ErrorType;
}

export const PERSON_PREFERENCE_UPDATE_REQUEST = 'PERSON_PREFERENCE_UPDATE_REQUEST';
export const PERSON_PREFERENCE_UPDATE_SUCCESS = 'PERSON_PREFERENCE_UPDATE_SUCCESS';
export const PERSON_PREFERENCE_UPDATE_FAILURE = 'PERSON_PREFERENCE_UPDATE_FAILURE';

export interface PersonPreferenceUpdateRequestAction {
    type: typeof PERSON_PREFERENCE_UPDATE_REQUEST;
    payload: PersonPreferenceUpdateCommand;
}

export interface PersonPreferenceUpdateSuccessAction {
    type: typeof PERSON_PREFERENCE_UPDATE_SUCCESS;
    payload: PersonPreferenceViewModel;
}

export interface PersonPreferenceUpdateFailureAction {
    type: typeof PERSON_PREFERENCE_UPDATE_FAILURE;
    id: number;
    error: ErrorType;
}

export const PERSON_PREFERENCE_DELETE_REQUEST = 'PERSON_PREFERENCE_DELETE_REQUEST';
export const PERSON_PREFERENCE_DELETE_SUCCESS = 'PERSON_PREFERENCE_DELETE_SUCCESS';
export const PERSON_PREFERENCE_DELETE_FAILURE = 'PERSON_PREFERENCE_DELETE_FAILURE';

export interface PersonPreferenceDeleteRequestAction {
    type: typeof PERSON_PREFERENCE_DELETE_REQUEST;
    id: number;
}

export interface PersonPreferenceDeleteSuccessAction {
    type: typeof PERSON_PREFERENCE_DELETE_SUCCESS;
    id: number;
}

export interface PersonPreferenceDeleteFailureAction {
    type: typeof PERSON_PREFERENCE_DELETE_FAILURE;
    id: number;
    error: ErrorType;
}
